import Input from '../Input';
import { FormEventHandler, useEffect, useState } from 'react';
import adminService from '../../utils/api-calls/adminService';
import useLoading from '../../contexts/LoadingContext';
import { useTranslation } from 'react-i18next';

export default function AddAdmin({ onBack }: { onBack: () => void }) {
  const [t] = useTranslation(['common', 'admin']);
  const { setIsLoading } = useLoading();
  const [errorMessage, setErrorMessage] = useState('');

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cPassword, setcPassword] = useState('');
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setErrorMessage('');
    if (username && password && email && cPassword) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [username, password, email, cPassword]);

  const onSubmit: FormEventHandler = (e) => {
    e.preventDefault();
    if (password !== cPassword) {
      setErrorMessage(t('confirm_passwd_fail', '密碼不符，請重新確認密碼'));
      return;
    }

    setIsLoading(true);
    adminService
      .createAdminMember({ username, password, email })
      .then(() => onBack())
      .catch((error) => setErrorMessage(error.message))
      .finally(() => setIsLoading(false));
  };

  return (
    <form
      className="flex flex-col h-full w-full items-center pt-5 px-6"
      onSubmit={onSubmit}
    >
      <div className="flex items-center w-full relative">
        <button
          className="flex items-center text-group-primary font-medium absolute left-0"
          type="button"
          onClick={onBack}
        >
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <span className="text-group-primary text-xl text-center font-medium flex-grow">
          {t('add_admin', '新增管理員', { ns: 'admin' })}
        </span>
      </div>
      <span className="mt-5 mb-4 border-t w-full border-[#d9d9d9]"></span>
      <div className="space-y-4 w-full">
        <Input
          title={t('username', '使用者名稱')}
          placeholder={t('username_placeholder', '請輸入使用者名稱')}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input
          title={t('email', 'Email')}
          placeholder={t('email_placeholder', '請輸入 Email')}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          title={t('passwd', '密碼')}
          placeholder={t('passwd_placeholder', '請輸入密碼')}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Input
          title={t('confirm_passwd', '確認密碼')}
          placeholder={t('confirm_passwd_placeholder', '請再次輸入密碼')}
          type="password"
          value={cPassword}
          onChange={(e) => setcPassword(e.target.value)}
        />
      </div>

      {errorMessage ? (
        <span className="text-sm text-error mt-2">{errorMessage}</span>
      ) : (
        <></>
      )}

      <button
        className="bg-group-primary text-white py-3 px-8 rounded text-center disabled:opacity-30 disabled:cursor-not-allowed mt-6 mb-5"
        disabled={!isValid}
        type="submit"
      >
        {t('submit', '送出')}
      </button>
    </form>
  );
}
